import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "../style/Footer.module.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaTelegram,
  FaXTwitter,
  FaPinterest,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaLocationDot,
} from "react-icons/fa6";
import Logo from "../assets/logowhite.png";
import { Link } from "react-router-dom";
import { REGISTER_URL } from "../config/urls";
import Play from "../assets/play.png";
import App from "../assets/app.png";

const Footer = () => {
  const { t } = useTranslation();
  
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <footer className={styles.footer}>
      {/* Main Footer Content */}
      <div className={styles.mainFooter}>
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2>{t('footer.registerPromo')}</h2>
              <p className="promo">{t('footer.freeDemoAccount')}</p>
            </Col>
            <Col md={6} className="text-md-end">
              <Button
                href={REGISTER_URL}
                variant="primary"
                className={`${styles.btn_main} me-3`}
              >
                {t('footer.registerNow')}
              </Button>
              <Button
                id="footerTryDemoBtn"
                href={REGISTER_URL}
                variant="outline-primary"
                className={`${styles.btn_main2} me-3`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('footer.tryDemo')}
              </Button>
            </Col>
          </Row>
          <div className={styles.footer_company}>
            <Row>
              {/* Logo and Address */}
              <Col lg={6} className="mb-4">
                <div className={styles.logoContainer}>
                  <img
                    src={Logo}
                    alt="ABET LLC Logo"
                    className="img-fluid"
                  />
                </div>
                <address className={styles.address}>
                  <div className={styles.addressItem}>
                    <FaLocationDot className={styles.contactIcon} />
                    <span>1618, Sq Manastirski livadi, 34 Ralevista street, sofia,
                    Bulgaria, P.O.Box 1404.</span>
                  </div>
                  <div className={styles.addressItem}>
                    <FaEnvelope className={styles.contactIcon} />
                    <span>Info@abetglobal.com</span>
                  </div>
                  <div className={styles.addressItem}>
                    <FaPhone className={styles.contactIcon} />
                    <span>+35924928517</span>
                  </div>
                  <p className={styles.companyInfoText}>
                    {t('footer.companyInfo')}
                  </p>
                </address>
              </Col>

              <div className="mb-4 col-lg-3 col-6">
                <h3 className={styles.footerHeading}>{t('footer.quickLinks')}</h3>
                <ul className={styles.footerLinks}>
                  <li>
                    <Link onClick={handleClick} to="/about">
                      {t('footer.aboutUs')}
                    </Link>
                  </li>
                  <li>
                    <a href="https://api.whatsapp.com/send/?phone=%2B447548718055&text&type=phone_number&app_absent=0">
                      {t('footer.support')}
                    </a>
                  </li>
                  <li>
                    <Link onClick={handleClick} to="/faqs">
                      {t('footer.faqs')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={handleClick} to="/contact">
                      {t('footer.contactUs')}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Get The App */}
              <div className="mb-4 col-lg-3 col-6">
                <h3 className={styles.footerHeading}>{t('footer.getTheApp')}</h3>
                <div className={styles.appButtons}>
                  <a href="#">
                    <img
                      src={Play}
                      alt="Download App"
                      className="img-fluid mb-2"
                    />
                  </a>
                  <a href="#">
                    <img src={App} alt="Download App" className="img-fluid" />
                  </a>
                </div>
              </div>
              {/* Footer Navigation Columns */}
            </Row>
          </div>
          <Row xs={2} lg={4}>
            {/* Trading Accounts */}
            <Col className="mb-4">
              <h3 className={styles.footerHeading}>{t('footer.tradingAccounts')}</h3>
              <ul className={styles.footerLinks}>
                <li>
                  <Link onClick={handleClick} to="/micro/">
                    {t('navbar.micro')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/raw-spread/">
                    {t('navbar.rawSpread')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/standard/">
                    {t('navbar.standard')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/prime/">
                    {t('navbar.prime')}
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Trading Instruments */}
            <Col className="mb-4">
              <h3 className={styles.footerHeading}>{t('footer.tradingInstruments')}</h3>
              <ul className={styles.footerLinks}>
                <li>
                  <Link onClick={handleClick} to="/forex/">
                    {t('navbar.forex')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/indices/">
                    {t('navbar.indices')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/energies/">
                    {t('navbar.energies')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/metals/">
                    {t('navbar.metals')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/cryptocurrency/">
                    {t('navbar.cryptocurrency')}
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Trading Conditions */}
            <Col className="mb-4">
              <h3 className={styles.footerHeading}>{t('footer.tradingConditions')}</h3>
              <ul className={styles.footerLinks}>
                <li>
                  <Link onClick={handleClick} to="/execution-policy/">
                    {t('navbar.executionPolicy')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/spreads/">
                    {t('navbar.spreads')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/margin-leverage/">
                    {t('footer.marginLeverage')}
                  </Link>
                </li>
              </ul>
            </Col>

            {/* MT5 Platforms */}
            <Col className="mb-4">
              <h3 className={styles.footerHeading}>{t('footer.mt5Platforms')}</h3>
              <ul className={styles.footerLinks}>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('navbar.mt5ForPc')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('navbar.mt5ForMac')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('navbar.mt5ForWebTrader')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('footer.mt5Ipad')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('footer.mt5Iphone')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('navbar.mt5ForAndroid')}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClick} to="/meta-trader-5/">
                    {t('footer.mt5AndroidTablet')}
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>

          {/* Legal Links */}
          <div className={styles.legalLinks}>
            <ul>
              <li>
                <Link onClick={handleClick} to="/privacy-policy">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link onClick={handleClick} to="/legal-documents">
                  {t('footer.legalDocuments')}
                </Link>
              </li>

              <li>
                <Link onClick={handleClick} to="/risk">
                  {t('footer.riskDisclosure')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Text */}
          <div className={styles.legalText}>
            <p>
              {t('footer.legalRegistration')}
            </p>
            <p>
              <strong>{t('footer.riskWarningTitle')}</strong> {t('footer.riskWarningText')}
            </p>
            <p>
              {t('footer.advisoryDisclaimer')}
            </p>
            <p>
              {t('footer.jurisdictionNotice')}
            </p>
            <p>
              {t('footer.minorProtection')}
            </p>
          </div>

          {/* Copyright and Social */}
          <Row className={styles.copyrightSection}>
            <Col md={6} className="mb-3 mb-md-0">
              <div className={styles.socialIcons}>
                <a
                  href="https://www.facebook.com/abetglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://www.linkedin.com/company/abetglobal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Connect on LinkedIn"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.instagram.com/abet.global"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://x.com/abet_global"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on X (Twitter)"
                >
                  <FaXTwitter />
                </a>
                <a
                  href="https://www.pinterest.com/abetglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Pinterest"
                >
                  <FaPinterest />
                </a>
                <a
                  href="https://www.youtube.com/@abetglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Subscribe on YouTube"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://t.me/abet_global"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Join us on Telegram"
                >
                  <FaTelegram />
                </a>
              </div>
            </Col>
            <Col md={6} className="text-md-end">
              <p>{t('footer.copyright')}</p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
